import React from 'react';

import * as styles from './sync-content-loader.scss';

interface SyncContentLoaderProps {
  width?: string | number;
  height?: string | number;
}

export const SyncContentLoader = ({ width = '100%', height = '14px' }: SyncContentLoaderProps) => (
  <div className={styles.syncContentLoader} style={{ width, height }} data-testid="sync-content-loader" />
);
